export const BankApplicationStages = {
  BA_ACCOUNT_OPENED: "BA_ACCOUNT_OPENED",
  BA_SENT_TO_SALES: "BA_SENT_TO_SALES",
};
